import './testimonials.component.scss'
import HolyStars from 'holy-stars'

function initStars() {
  document.querySelectorAll('.testimonials__stars').forEach((stars) => {
    new HolyStars({
      el: stars,
      rate: 5,
      size: 26,
      primaryColor: '#F8D20D',
      secondColor: '#ddd'
    })
  })
}

function handleLoadMore() {
  const trigger = document.querySelector('.testimonials__more button')
  if (trigger) {
    trigger.addEventListener('click', function () {
      const tests = document.querySelectorAll('.testimonials__row')
      tests.forEach((test) => {
        test.classList.remove('hidden')
      })
      trigger.style.display = 'none'
    })
  }
}
handleLoadMore()
initStars()